import gql from 'graphql-tag';

export default gql`
  mutation deleteGroupRole($id: UUID!) {
    deleteGroupRole(_id: $id)
  }
`;
